import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const optionStyleObject = css`
  padding: ${theme.spacing(2)};
  gap: ${theme.spacing(1)};
  display: flex;
  flex: 1;
  position: relative;
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid;
  border-color: ${theme.colors.neutral40};
  color: ${theme.colors.primary50};
  transition: color 250ms ease-out, border-color 250ms ease-out;
  background-color: ${theme.colors.white};

  &[aria-checked='true'] {
    border-color: ${theme.colors.primary50};
  }
  :hover {
    background-color: ${theme.colors.neutral5};
  }
  :focus {
    border-color: ${theme.colors.primary50};
    outline-color: ${theme.colors.primary50};
    outline-offset: 4px;
  }
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const optionContentContainerStyleObject = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: ${theme.spacing(1)};
  pointer-events: none;
`;

const optionContentStyleObject = css`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  gap: ${theme.spacing(0.5)};
  pointer-events: none;
  width: 100%;
`;

const optionRadioStyle = css`
  width: 20px;
  height: 20px;
  pointer-events: none;
`;

const optionIconStyleObject = css`
  align-self: center;
  width: ${theme.spacing(5)};
`;

const fieldStyleObject = css`
  display: flex;
  min-height: 52px;
  gap: ${theme.spacing(2)};
`;

const descriptionStyles = css`
  width: 100%;
`;

export const RadioCardStyles = {
  radioCardField: fieldStyleObject,
  radioCard: optionStyleObject,
  radioCardContentContainer: optionContentContainerStyleObject,
  radioCardContent: optionContentStyleObject,
  radioCheckbox: optionRadioStyle,
  radioIcon: optionIconStyleObject,
  radioDescription: descriptionStyles,
};
